import React from 'react';
import { ShoppingCartIcon, MonitorIcon, CarIcon, PlayIcon, UtensilsIcon } from 'lucide-react';
export const PartnersGrid = () => {
  const partners = [{
    id: 1,
    name: 'Rimi',
    icon: <ShoppingCartIcon size={24} data-id="element-156" />
  }, {
    id: 2,
    name: 'Apple',
    icon: <MonitorIcon size={24} data-id="element-157" />
  }, {
    id: 3,
    name: 'Bolt',
    icon: <CarIcon size={24} data-id="element-158" />
  }, {
    id: 4,
    name: 'Netflix',
    icon: <PlayIcon size={24} data-id="element-159" />
  }, {
    id: 5,
    name: 'Food Delivery',
    icon: <UtensilsIcon size={24} data-id="element-160" />
  }, {
    id: 6,
    name: 'Electronics',
    icon: <div size={24} data-id="element-161" />
  }];
  return <section className="my-12" data-id="element-162">
      <h2 className="text-lg font-bold mb-6" data-id="element-163">Our Partners</h2>
      <div className="grid grid-cols-3 md:grid-cols-6 gap-4" data-id="element-164">
        {partners.map(partner => <div key={partner.id} className="aspect-square bg-white border border-gray-200 rounded-lg flex items-center justify-center" data-id="element-165">
            <div className="flex flex-col items-center" data-id="element-166">{partner.icon}</div>
          </div>)}
      </div>
    </section>;
};